var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jira_svg__a",
    d: "M0 .894h51.944V54H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.733 17.95l9.348 9.256 7.892-7.813a12.997 12.997 0 010-18.452L.733 17.95z",
    id: "jira_svg__q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.232 8.232c5.352 5.165 5.352 13.534 0 18.696L18.155 9.774 8.4.354.232 8.233z",
    id: "jira_svg__G"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.973 35.275l-7.937-7.848 7.937-7.851 7.893 7.863-7.893 7.836zm25.34-9.335L28.145 3.114 25.973.894 8.57 18.09.619 25.94a2.09 2.09 0 000 2.97l15.887 15.74L25.96 54l17.403-17.198.271-.269 7.68-7.594a2.09 2.09 0 00.015-2.98l-.016-.019z",
    fill: "#2684FF",
    mask: "url(#jira_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    mask: "url(#jira_svg__d)",
    d: "M17.973 16.83L8.1 7.057 14.28.94h3.693z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    mask: "url(#jira_svg__f)",
    d: "M17.973 19.796L6.603 8.54 8.1 7.057l9.873 9.774z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#085CD6",
    mask: "url(#jira_svg__h)",
    d: "M17.973 22.762L5.104 10.022 6.602 8.54l11.371 11.256z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F66E0",
    mask: "url(#jira_svg__j)",
    d: "M17.973 22.993l-1.382 1.367L3.607 11.506l1.497-1.482 12.87 12.737z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1770EB",
    mask: "url(#jira_svg__l)",
    d: "M16.591 24.36l-1.497 1.483L2.109 12.988l1.498-1.483z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AF5",
    mask: "url(#jira_svg__n)",
    d: "M15.093 25.843l-1.375 1.362h-.245L.733 14.593v-.242l1.376-1.363z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    mask: "url(#jira_svg__p)",
    d: "M10.477 27.205L.733 17.559v-2.966l12.74 12.612z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    mask: "url(#jira_svg__r)",
    d: "M.733 17.559l9.744 9.646H.733z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    mask: "url(#jira_svg__t)",
    d: "M.232 10.635l10.413 10.029-6.49 6.265H.233z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    mask: "url(#jira_svg__v)",
    d: "M.232 7.647l11.963 11.52-1.55 1.496L.232 10.635z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#085CD6",
    mask: "url(#jira_svg__x)",
    d: "M.232 4.659L13.744 17.67l-1.55 1.496L.233 7.647z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F66E0",
    mask: "url(#jira_svg__z)",
    d: "M.232 4.593L1.748 3.13l13.545 13.045-1.55 1.497L.233 4.659z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1770EB",
    mask: "url(#jira_svg__B)",
    d: "M1.748 3.13l1.55-1.496 13.545 13.045-1.55 1.496z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E7AF5",
    mask: "url(#jira_svg__D)",
    d: "M3.298 1.634L4.622.354h.45l13.083 12.6v.458l-1.312 1.267z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    mask: "url(#jira_svg__F)",
    d: "M8.175.354l9.979 9.612v2.988L5.073.354z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jira_svg__H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jira_svg__G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    mask: "url(#jira_svg__H)",
    d: "M18.154 9.966L8.176.354h9.978z"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgJira as ReactComponent };